import { loadScript, serializeParam, objectAssign } from '@tencent/midas-util';

let _tmpRes = null;
window.IPAY = window.IPAY || {};
IPAY._action_report_callback = function (res) {
  _tmpRes = res;
}

/**
 * @param action 不能为空
 * @param ch 只是统计作用，可以为空
 * @param sevice 只是统计作用，可以为空
 * @param sessionid 只是统计作用，可以为空
 */
export default function (_params, extend, callback, timeout) {
  let params = objectAssign({
    ch: 'self',
    r: Math.random()
  }, _params);

  if (!params.action) {
    throw new Error('action_report需要action字段');
  }

  if (extend) {
    params.extend = encodeURIComponent(serializeParam(extend, true));
  }

  let url = 'https://upayportal.qq.com/cgi-bin/action_report.fcg?' + serializeParam(params, true);

  loadScript(url, (args, isLoaded) => {
    let res;
    if (!isLoaded) {
      if (isLoaded === null) {
        //请求超时
        res = {
          result: "-9997",
          path: url,
        };
      } else {
        //cgi返回失败
        res = {
          result: "-9999",
          path: url,
        };
      }
    } else {
      //cgi返回格式错误
      if (!_tmpRes) {
        res = {
          ret: "-9998",
          path: url,
        };
      } else {
        res = _tmpRes;
      }
    }
    _tmpRes = null;

    callback && callback(res);
  }, null, "utf-8", timeout)
}

